/**
 * /en/admin/structure/paragraphs_type/form_element_checkbox/fields
 */

import {ATTRIBUTES} from "@js/constants/html-constants.es6.js";
import FormElementParagraph from "@js/paragraphs/form-element-paragraph.es6.js";
import LabelFormElementParagraphField
  from "@js/fields/form-element-label-paragraph-field.es6.js";

export default class CheckboxFormElementParagraph extends FormElementParagraph {
  get label() {
    return new LabelFormElementParagraphField({
      machineName: 'field_form_label',
      parentElement: this,
    });
  }

  get hasValue() {
    return this.element.$().prop(ATTRIBUTES.CHECKED);
  }

  get value() {
    return this.hasValue;
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_checkbox',
      parentElement,
    });
  }

  validate() {
    if (this.required) {
      return this.hasValue;
    }

    return true;
  }

  check() {
    this.element.$().prop(ATTRIBUTES.CHECKED, true);
  }

  uncheck() {
    this.element.$().prop(ATTRIBUTES.CHECKED, false);
  }
}
